import angular from 'angular';

import ViewStudentAccountController from './view-student-account-controller';

const viewStudentAccount = angular.module('viewStudentAccount', []);
viewStudentAccount.controller('ViewStudentAccountController', ViewStudentAccountController);

export default viewStudentAccount.name;
